import { StoreBase } from '@/store/base/StoreBase'
import {Cookies} from '@/shared/helpers/Cookies'

export type CallType = 'one-to-one' | 'group';
export type CallStatus = 'outgoing' | 'incoming' | 'active' | 'ended' | 'initiating';

export interface CallInfo {
  userId: number;
  callId: number;
  chatId: number;
  callerId: number;
  calleeId?: number;
  call_type: 'audio' | 'video';
  type: CallType;
  status: CallStatus;
  liveKitRoomName?: string;
  liveKitToken?: string;
  liveKitUrl?: string;
  date?: Date;
}

export interface CallState {
  isLoading: boolean;
  incomingCall: CallInfo | null;
  outgoingCall: CallInfo | null;
  activeCall: CallInfo | null;
}

export class CallsStore extends StoreBase<CallState> {
  public static getNamespace(): string {
    return 'call'
  }

  constructor() {
    super(CallsStore.getNamespace())
  }

  public static get(): {
    callStore: CallsStore;
    callState: CallState;
  } {
    const namespace = this.getNamespace()

    if (!this._hasModule(namespace)) {
      this._register<CallState>(namespace, {
        isLoading: false,
        incomingCall: null,
        outgoingCall: null,
        activeCall: null,
      })
    }

    const store = new CallsStore()

    return {
      callStore: store,
      callState: store.state,
    }
  }

  public updateCallType(callId: number, newType: 'audio' | 'video') {
    this.dispatch(async (state) => {
      if (state.activeCall && state.activeCall.callId === callId) {
        state.activeCall.call_type = newType
      }
      if (state.incomingCall && state.incomingCall.callId === callId) {
        state.incomingCall.call_type = newType
      }
      if (state.outgoingCall && state.outgoingCall.callId === callId) {
        state.outgoingCall.call_type = newType
      }
    })
    this._syncWithCookies()
  }

  private _syncWithCookies() {
    const cookieOptions = {
      domain: window.location.hostname,
      path: '/',
    }
    if (this.state.activeCall) {
      Cookies.set('call', JSON.stringify(this.state.activeCall), cookieOptions)
    } else {
      Cookies.remove('call', cookieOptions)
    }
  }

  private _removeCookies() {
    const cookieOptions = {
      domain: window.location.hostname,
      path: '/',
    }
    Cookies.remove('call', cookieOptions)
  }
}
